var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geoErrorBanner"},[_c('p',{staticClass:"geoErrorBanner__msg"},[_vm._v(_vm._s(_vm.errorMsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }